import { EMAIL_CONFIRMATION_PAGE_ID } from 'pages/auth/config';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { showEmailConfirmationModule } from '../../actions';

export const useEmailConfirmationPageData = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(showEmailConfirmationModule(EMAIL_CONFIRMATION_PAGE_ID));
    }, [dispatch]);
};
